var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    viewBox: "0 0 16 12",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "b",
    height: 11.428571,
    rx: 1,
    width: 16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d0d0d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed1623"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d70915"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fee044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcdb32"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#fff",
    fillRule: "evenodd",
    xlinkHref: "#b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v1.52381h-16z",
    fill: "url(#c)",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 6.095238h16v1.52381h-16z",
    fill: "url(#c)",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 3.809524h16v2.285714h-16z",
    fill: "url(#d)",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 1.52381h16v2.285714h-16z",
    fill: "url(#e)",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 9.904762h16v1.52381h-16z",
    fill: "url(#d)",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 7.619048h16v2.285714h-16z",
    fill: "url(#e)",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 5.714286,
    fill: "url(#a)",
    mask: "url(#f)",
    r: 2.666667
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.37562779 4.32800874c-.07595713-.07595713-.07800874-.19705636 0-.2750651l.10588728-.10588728c.07595713-.07595713.19274642-.20674642.2579436-.27652994l.09301668-.0749163c.0925213.01294417.24158949-.02762858.3369264-.00910877l.09040099.0699986c.06690911.08451274.08599337.22333636.03279398.32973518l-.20424106.40848217c-.04879749.09759496-.08835566.26506697-.08835566.3671875 0 .1051971.07031253.22563243.17671131.27883182l.40848214.20424103c.09759497.04879747.23649668.14814102.30942499.22106931l.49647741.49647741c.07329577.07329574.09755741.20302619.04435802.30942502l-.20424107.40848224c-.04879749.09759499-.14787947.11718752-.22588823.03917874l-.10588724-.10588733c-.07595718-.07595717-.19705638-.07800878-.27506514 0l-.10588724.10588733c-.07595718.07595717-.13753257.22588827-.13753257.32800881 0 .10519709.05952381.24999997.13753257.32800869l.10588724.10588725c.07595718.0759571.04785448.1375325-.05118705.1375325h-.7654179c-.10422697 0-.12919581-.05952381-.05118705-.13753255l.10588724-.10588728c.07595718-.07595713.13753257-.22588821.13753257-.32800874 0-.1051971-.08835566-.19047619-.19047619-.19047619-.10519711 0-.25.05952381-.32800874.13753255l-.10588728.10588728c-.07595713.07595713-.19705636.07800874-.2750651 0l-.10588728-.10588728c-.07595713-.07595713-.07800874-.19705636 0-.2750651l.10588728-.10588729c.07595713-.07595712.21906971-.13753254.32979329-.13753254h.3773833c.10618262 0 .13081577-.06144496.06116045-.13110025l-.88065663-.88065665c-.07240466-.07240467-.07131486-.19088563.00161344-.26381393l.4964774-.49647739c.07329574-.07329575.07318987-.1922375-.00481887-.27024624z",
    fill: "url(#c)",
    mask: "url(#f)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUg);
export default __webpack_public_path__ + "static/media/UG.9e7b2d63ff482db5a385e9caa4df3655.svg";
export { ForwardRef as ReactComponent };